import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { white } from 'assets/sdgs';

const resolveSdgIcon = sdg => {
  const number = Number(sdg?.number);
  if (!Number.isFinite(number)) return null;
  const index = number - 1;
  return white?.[index] || null;
};

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  boxShadow: theme.custom.shadows[1],
  background: '#fff',
  borderRadius: theme.shape.borderRadius,
  marginRight: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
  padding: theme.spacing(0.5),
  paddingRight: theme.spacing(1),
}));

const IconContainer = styled('div')(({ theme, hex }) => ({
  display: 'flex',
  backgroundColor: hex,
  padding: 4,
  width: theme.spacing(4),
  height: theme.spacing(4),
  marginRight: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,

  '& svg': {
    width: '100%',
    height: '100%',
    margin: '0 auto',
  },
}));

const Title = styled('div')(() => ({
  fontSize: 12,
  lineHeight: 1.1,
  maxWidth: 130,
}));

const SdgItem = ({ sdg }) => {
  const Icon = resolveSdgIcon(sdg);
  return (
    <Container>
      <IconContainer hex={sdg?.color || sdg?.hex}>
        {Icon ? <Icon /> : sdg?.iconUrl ? <img src={sdg.iconUrl} alt="Sdg logo" /> : null}
      </IconContainer>
      <Title>{sdg?.title}</Title>
    </Container>
  );
};

SdgItem.propTypes = {
  sdg: PropTypes.object.isRequired,
};

export default SdgItem;
